import { useEffect } from "react";

/*
 * The error reasons the page shows right now (docs/assistant.md, "Screen
 * context"): each `ErrorMessage` on screen names its reason here while it
 * is mounted, and the chat tells the assistant the newest one with every
 * message. Structured, not pixels: the reason code, never the page itself.
 */

const shown: string[] = [];

/** Names an error reason on the page while the calling component is mounted. */
export function useShownError(reason: string | null | undefined): void {
  useEffect(() => {
    if (!reason) return;
    shown.push(reason);
    return () => {
      const at = shown.lastIndexOf(reason);
      if (at >= 0) shown.splice(at, 1);
    };
  }, [reason]);
}

/** The newest error reason on the page, if any. */
export function shownError(): string | null {
  return shown.at(-1) ?? null;
}
